export default "__VITE_ASSET__4063fd00__"